import { validatenull } from "./validate";
import { PUBLICK_KEY } from "@/const/rsa";
/* import {
    RSA
} from "@/util/SRA" */
import JSEncrypt from "encryptlong";
/* const stepType = {
    STATUS: 'STATUS',
    INIT_STATUS: 'INIT_STATUS',
    INVALID_STATUS: 'INVALID_STATUS',
    OPTION: 'OPTION'
} */

const statusType = {
  FORWARD: "FORWARD",
  BACK: "BACK",
};

/**
 *
 * @param {*} oarry
 * @param {*} option
 */
export const parseStatus = (oarry, option) => {
  let map = new Map();
  for (let i = 0; i < oarry.length; i++) {
    map.set(oarry[i].value, oarry[i].label);
  }
  let aa = map.get(option);
  return aa;
};

export const formatterDateToUTC = (data) => {
  var date = new Date(parseInt(data));
  let Y = date.getFullYear() + "-";
  let M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  let h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  let m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
  let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return Y + M + D + h + m + s;
};

export const formatYMDHMS = (fmt) => {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};

export const randomString = (len) => {
  len = len || 32;
  var $chars =
    "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  var maxPos = $chars.length;
  var pwd = "";
  for (var i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
};

export const getParams = (params, timeStamp, appId, nonce, method) => {
  return (
    params + "___" + timeStamp + "___" + nonce + "___" + appId + "___" + method
  );
};

export const getSign = (url, method) => {
  let RSAModel = new Object();
  RSAModel.timeStamp = new Date().valueOf();
  RSAModel.appId = getAppId(url);
  RSAModel.nonce = randomString(64);
  let publicKey = getPublicKey(url);
  let uri = getSignUrl(url);
  let message = getParams(
    uri,
    RSAModel.timeStamp,
    RSAModel.appId,
    RSAModel.nonce,
    method
  );
  // let encrypt_rsa = new RSA.RSAKey();
  // encrypt_rsa = RSA.KEYUTIL.getKey(publicKey);
  // RSAModel.sign = encrypt_rsa.encrypt(message);
  const encryptor = new JSEncrypt();
  encryptor.setKey(publicKey);
  RSAModel.sign = encryptor.encryptLong(message);
  // RSAModel.sign = RSA.hex2b64(encStr); // 该方法和其他编程语言不兼容，暂时屏蔽\
  return RSAModel;
};

export const getSignUrl = (url) => {
  return url.substring(findCharIndex(url, "/", 2), url.length);
};

export const findCharIndex = (str, cha, num) => {
  var x = str.indexOf(cha);
  for (var i = 0; i < num; i++) {
    x = str.indexOf(cha, x + 1);
  }
  return x;
};

export const getPublicKey = (url) => {
  for (let app of PUBLICK_KEY) {
    if (url.indexOf(app.appId) != -1) {
      return app.publicKey;
    }
  }
  return "";
};

export const getAppId = (url) => {
  for (let app of PUBLICK_KEY) {
    if (url.indexOf(app.appId) != -1) {
      return app.appId;
    }
  }
  return "";
};

export const formatterTime = (time) => {
  var date = new Date(time);

  var year = date.getFullYear(),
    month = date.getMonth() + 1, //月份是从0开始的
    day = date.getDate(),
    hour = date.getHours(),
    min = date.getMinutes(),
    sec = date.getSeconds();
  var newTime =
    year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
  return newTime;
};
// 表格展示：时间戳与 ISO 8601 统一格式化，后端已是展示格式字符串时原样返回
export const displayTime = (v) => {
  if (v == null || v === "") return "";
  if (typeof v === "number") return formatterTime(v);
  if (typeof v !== "string") return "";
  if (/^\d+$/.test(v)) return formatterTime(Number(v));
  // 仅处理带 T 的 ISO 串；"yyyy-MM-dd HH:mm:ss" 是后端展示格式，原样返回避免丢掉补零
  if (/^\d{4}-\d{2}-\d{2}T/.test(v)) {
    const t = new Date(v).getTime();
    if (!isNaN(t)) return formatterTime(t);
  }
  return v;
};
// 转换到年月日
export const formatterDate = (time) => {
  var date = new Date(time);

  var year = date.getFullYear(),
    month = date.getMonth() + 1, //月份是从0开始的
    day = date.getDate();
  var newTime = year + "-" + month + "-" + day;
  return newTime;
};
/**
 * 设置灰度模式
 */
export const toggleGrayMode = (status) => {
  if (status) {
    document.body.className = document.body.className + " grayMode";
  } else {
    document.body.className = document.body.className.replace(" grayMode", "");
  }
};
/**
 * 设置主题
 */
export const setTheme = (name) => {
  document.body.className = name;
};

export const getMenu = (steppings, status) => {
  for (let i = 0; i < steppings.length; i++) {
    if (steppings[i].code == status) {
      if (steppings[i].statusType == statusType.FORWARD) {
        return getStepObj(steppings, steppings[i].nextStep);
      } else {
        return getStepObj(steppings, steppings[i].lastStep);
      }
    }
  }
};

export const getMenuSteps = (steppings, status) => {
  let menuSteps = new Array();
  for (let i = 0; i < steppings.length; i++) {
    if (steppings[i].code == status) {
      if (steppings[i].statusType == statusType.FORWARD) {
        let stepIndex = steppings[i].nextStep.split(",");
        for (let index of stepIndex) {
          let obj = getStepObj(steppings, index);
          if (null != obj && undefined != obj) menuSteps.push(obj);
        }
        return menuSteps;
      } else {
        let obj = getStepObj(steppings, steppings[i].lastStep);
        if (null != obj && undefined != obj) menuSteps.push(obj);
        return menuSteps;
      }
    }
  }
};

export const getMenuName = (steppings, status) => {
  for (let i = 0; i < steppings.length; i++) {
    if (steppings[i].code == status) {
      if (steppings[i].statusType == statusType.FORWARD) {
        return getStepObj(steppings, steppings[i].nextStep).name;
      } else {
        return getStepObj(steppings, steppings[i].lastStep).name;
      }
    }
  }
};

export const getStatusName = (steppings, status) => {
  for (let i = 0; i < steppings.length; i++) {
    if (steppings[i].code == status) {
      return steppings[i].name;
    }
  }
};

export const getStepObj = (steppings, step) => {
  for (let i = 0; i < steppings.length; i++) {
    if (steppings[i].step == step) return steppings[i];
  }
};

export const getStep = (steppings, status) => {
  for (let i = 0; i < steppings.length; i++) {
    if (steppings[i].code == status) {
      return steppings[i].step;
    }
  }
};
export const getStepType = (steppings, status) => {
  for (let i = 0; i < steppings.length; i++) {
    if (steppings[i].code == status) {
      return steppings[i].stepType;
    }
  }
};
export const getStatusType = (steppings, status) => {
  for (let i = 0; i < steppings.length; i++) {
    if (steppings[i].code == status) {
      return steppings[i].statusType;
    }
  }
};

/**
 * 获取字典
 */
export const setDic = (dicData, DIC) => {
  return typeof dicData == "string" ? DIC : dicData;
};
/**
 * 设置px
 */
export const setPx = (val, defval) => {
  if (validatenull(val)) {
    val = defval;
  }
  val = val + "";
  if (val.indexOf("%") == -1) {
    val = val + "px";
  }
  return val;
};
/**
 * 动态获取组件
 */
export const getComponent = (type) => {
  if (type == "select") {
    return "crudSelect";
  } else if (type == "radio") {
    return "crudRadio";
  } else if (type == "checkbox") {
    return "crudCheckbox";
  } else if (type == "date") {
    return "crudDate";
  } else {
    return "crudInput";
  }
};
/**
 * 加密处理
 */
export const encryption = (params) => {
  let { data, type, param, key } = params;
  let result = JSON.parse(JSON.stringify(data));
  if (type == "Base64") {
    param.forEach((ele) => {
      result[ele] = btoa(result[ele]);
    });
  } else if (type == "Aes") {
    param.forEach((ele) => {
      result[ele] = window.CryptoJS.AES.encrypt(result[ele], key).toString();
    });
  }
  return result;
};

/**
 * 设置浏览器头部标题
 */
export const setTitle = function (title) {
  title = title ? `${title}——慧家后台管理系统` : "慧家后台管理系统";
  window.document.title = title;
};
/**
 * 浏览器判断是否全屏
 */
export const fullscreenToggel = () => {
  if (fullscreenEnable()) {
    exitFullScreen();
  } else {
    reqFullScreen();
  }
};
/**
 * esc监听全屏
 */
export const listenfullscreen = (callback) => {
  function listen() {
    callback();
  }
  document.addEventListener("fullscreenchange", function () {
    listen();
  });
  document.addEventListener("mozfullscreenchange", function () {
    listen();
  });
  document.addEventListener("webkitfullscreenchange", function () {
    listen();
  });
  document.addEventListener("msfullscreenchange", function () {
    listen();
  });
};
/**
 * 浏览器判断是否全屏
 */
export const fullscreenEnable = () => {
  var isFullscreen =
    document.fullscreenEnabled ||
    window.fullScreen ||
    document.mozFullscreenEnabled ||
    document.webkitIsFullScreen;
  return isFullscreen;
};

/**
 * 浏览器全屏
 */
export const reqFullScreen = () => {
  if (document.documentElement.requestFullScreen) {
    document.documentElement.requestFullScreen();
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.documentElement.webkitRequestFullScreen();
  } else if (document.documentElement.mozRequestFullScreen) {
    document.documentElement.mozRequestFullScreen();
  }
};
/**
 * 浏览器退出全屏
 */
export const exitFullScreen = () => {
  if (document.documentElement.requestFullScreen) {
    document.exitFullScreen();
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.webkitCancelFullScreen();
  } else if (document.documentElement.mozRequestFullScreen) {
    document.mozCancelFullScreen();
  }
};
/**
 * 递归寻找子类的父类
 */

export const findParent = (menu, id) => {
  let m = null;
  if (menu.length > 0) {
    for (let i = 0; i < menu.length; i++) {
      if (menu[i].id == id) {
        m = menu[i];
        break;
      } else {
        let c = menu[i].children;
        if (c != null) {
          let m1 = findParent(c, id);
          if (m1 != null) {
            m = m1;
            break;
          }
        }
      }
    }
  }
  return m;
};

export const findParentTwo = (menus, id) => {
  for (let j = 0; j < menus.length; j++) {
    if (null != findParentTwo(menus[j].children, id))
      findParentTwo(menus[j].children, id);
  }
};

/**
 * 总体路由处理器
 */
export const resolveUrlPath = (url, name,token) => {
  let reqUrl = url;
  if (token) {
    reqUrl = `${reqUrl}?token=${token}`;
    window.open(reqUrl, "_blank");
  }else{
   if (url.indexOf("http") != -1 || url.indexOf("https") != -1) {
    reqUrl = `/myiframe/urlPath?src=${reqUrl}&name=${name}`;
  } else {
    reqUrl = `${reqUrl}`;
  }
  return reqUrl; 
  }

  
};
/**
 * 总体路由设置器
 */
export const setUrlPath = ($route) => {
  let value = "";
  if ($route.query.src) {
    value = $route.query.src;
  } else {
    value = $route.path;
  }
  return value;
};
/**
 * 动态插入css
 */

export const loadStyle = (url) => {
  const link = document.createElement("link");
  link.type = "text/css";
  link.rel = "stylesheet";
  link.href = url;
  const head = document.getElementsByTagName("head")[0];
  head.appendChild(link);
};
/**
 * 根据字典的value显示label
 */
export const findByvalue = (dic, value) => {
  let result = "";
  if (validatenull(dic)) return value;
  if (
    typeof value == "string" ||
    typeof value == "number" ||
    typeof value == "boolean"
  ) {
    let index = 0;
    index = findArray(dic, value);
    if (index != -1) {
      result = dic[index].label;
    } else {
      result = value;
    }
  } else if (value instanceof Array) {
    result = [];
    let index = 0;
    value.forEach((ele) => {
      index = findArray(dic, ele);
      if (index != -1) {
        result.push(dic[index].label);
      } else {
        result.push(value);
      }
    });
    result = result.toString();
  }
  return result;
};

/**
 * 根据字典的value显示label
 */
export const findByLabel = (dic, label) => {
  let result = "";
  if (validatenull(dic)) return label;
  if (
    typeof label == "string" ||
    typeof label == "number" ||
    typeof label == "boolean"
  ) {
    let index = 0;
    index = findArrayLabel(dic, label);
    if (index != -1) {
      result = dic[index].value;
    } else {
      result = label;
    }
  } else if (label instanceof Array) {
    result = [];
    let index = 0;
    label.forEach((ele) => {
      index = findArray(dic, ele);
      if (index != -1) {
        result.push(dic[index].value);
      } else {
        result.push(label);
      }
    });
    result = result.toString();
  }
  return result;
};

/**
 * 根据字典的value查找对应的index
 */
export const findArrayLabel = (dic, label) => {
  for (let i = 0; i < dic.length; i++) {
    if (dic[i].label == label) {
      return i;
    }
  }
  return -1;
};

/**
 * 根据字典的value查找对应的index
 */
export const findArray = (dic, value) => {
  for (let i = 0; i < dic.length; i++) {
    if (dic[i].value == value) {
      return i;
    }
  }
  return -1;
};
/**
 * 生成随机len位数字
 */
export const randomLenNum = (len, date) => {
  let random = "";
  random = Math.ceil(Math.random() * 100000000000000)
    .toString()
    .substr(0, len ? len : 4);
  if (date) random = random + Date.now();
  return random;
};
/**
 * 打开小窗口
 */
export const openWindow = (url, title, w, h) => {
  // Fixes dual-screen position                            Most browsers       Firefox
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : screen.left;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : screen.top;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : screen.height;

  const left = width / 2 - w / 2 + dualScreenLeft;
  const top = height / 2 - h / 2 + dualScreenTop;
  const newWindow = window.open(
    url,
    title,
    "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=" +
      w +
      ", height=" +
      h +
      ", top=" +
      top +
      ", left=" +
      left
  );

  // Puts focus on the newWindow
  if (window.focus) {
    newWindow.focus();
  }
};

export const parseParam = (ojson) => {
  if (!ojson || typeof ojson !== 'object') return '';
  let s = "",
    name,
    key;
  for (let p in ojson) {
    if (!Object.prototype.hasOwnProperty.call(ojson, p)) continue;
    name = p;
    key = ojson[p];
    if (key === undefined || key === null || key === '') continue;
    s += "&" + name + "=" + encodeURIComponent(key);
  }
  return s ? s.substring(1) : '';
};
